/** Copy plain text, including browsers where the modern Clipboard API is unavailable. */
export async function copiarTexto(texto: string): Promise<void> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(texto);
      return;
    } catch {
      // Some mobile browsers deny clipboard permissions; try the selection fallback.
    }
  }

  const focoAnterior = document.activeElement;
  const seleccion = document.getSelection();
  const rangos = seleccion
    ? Array.from({ length: seleccion.rangeCount }, (_, i) => seleccion.getRangeAt(i).cloneRange())
    : [];
  const campo = document.createElement("textarea");
  campo.value = texto;
  campo.readOnly = true;
  campo.style.position = "fixed";
  campo.style.top = "0";
  campo.style.left = "0";
  campo.style.opacity = "0";
  campo.style.fontSize = "16px";
  document.body.appendChild(campo);

  try {
    campo.focus({ preventScroll: true });
    campo.select();
    campo.setSelectionRange(0, texto.length);
    if (!document.execCommand("copy")) throw new Error("No se pudo copiar el texto.");
  } finally {
    campo.remove();
    if (focoAnterior instanceof HTMLElement) focoAnterior.focus({ preventScroll: true });
    if (seleccion) {
      seleccion.removeAllRanges();
      rangos.forEach((rango) => seleccion.addRange(rango));
    }
  }
}
